import React, { Component } from 'react'
import { Link } from 'react-router'
import { HeaderView } from '@merchant-backend/common-components'
import { LIVE_MANAGE_PATH } from '@constant'
import Describe from './Describe'
import ChargeForm from './ChargeForm'
import Agreement from './Agreement'

export default class extends Component {
  render() {
    const header = [<Link to={LIVE_MANAGE_PATH}>视频直播</Link>, '直播账户充值']
    return (
      <HeaderView header={header} title="直播账户充值">
        <Describe />
        <ChargeForm />
        <Agreement />
      </HeaderView>
    )
  }
}
